import { Layout } from '@sunwebgroup/uds-ui/layout'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useCMSPageField } from '@/cms/fields'
import { Footer } from '@/scopes/common/components'
import { CatalogueContent } from '@/scopes/common/components/Footer/CatalogueContent'
import { Header } from '@/scopes/common/components/Header'
import { createAccoListerApiClient } from '@/scopes/common/infrastructure/acco-lister/accoListerApiClient'
import { destinationMapAPIClient } from '@/scopes/common/infrastructure/api/destination-map'
import { createConsoleLogger } from '@/scopes/common/infrastructure/logging/consoleLogger'
import { DestinationCards } from '@/scopes/destinations/components/AllDestinations/DestinationCards/DestinationCards'
import Hero from '@/scopes/destinations/components/AllDestinations/Hero'
import { destinationActions } from '@/scopes/destinations/domain/actions'
import { createDestinationClient } from '@/scopes/destinations/infrastructure/api/destinationDataClient'
import { DestinationDependenciesProvider } from '@/scopes/destinations/infrastructure/depedencies/dependencies'
import { destinationStore } from '@/scopes/destinations/infrastructure/store/destination-store'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import styles from './Destination.module.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
})

function AllDestinations() {
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
      <Layout as="main" id="main-content" tabIndex={-1}>
        <Hero />
        <div className={styles.content}>
          <Breadcrumbs />
          <DestinationCards />
        </div>
      </Layout>
      <Footer>
        <CatalogueContent />
      </Footer>
    </QueryClientProvider>
  )
}

export default function Page() {
  const contextItemId = useCMSPageField('contextItemId')
  const datasourceId = useCMSPageField('DestinationPage.datasourceId')
  const template = useCMSPageField('template')
  const deskId = useCMSPageField('DestinationPage.deskId')

  // Is there a way we can make most of these dependencies optional?
  const actions = destinationActions({
    store: destinationStore,
    destinationMapApiClient: destinationMapAPIClient,
    destinationsSelectorClient: createDestinationClient({ contextItemId, datasourceId }),
    accoListerApiClient: createAccoListerApiClient({ contextItemId, datasourceId, template, deskId }),
    logger: createConsoleLogger(),
  })

  return (
    <DestinationDependenciesProvider dependencies={{ actions }}>
      <AllDestinations />
    </DestinationDependenciesProvider>
  )
}
